import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { accessToken } from '../utils/session';

export const PrivateRoute = ({
  component: Component,
  isAuthenticated,
  ...rest
}) => {
  return (accessToken() ? (
    <Outlet />
  ) : (
    <Navigate to="/login" />
  ));
};
